module.exports = __webpack_public_path__ + "img/icon_cooler_logo_n.f15bead2.png";